import { Link } from 'react-router-dom';
import LegalPageLayout, { LegalSection, LegalNote } from './LegalPageLayout';

export default function ConsentPage() {
  return (
    <LegalPageLayout title="Açık Rıza Metni" updated="Mayıs 2025">
      <div className="legal-intro">
        <p>
          Bu Açık Rıza Metni, NoteSwapp adlı mobil uygulama ve internet sitesi kapsamında kişisel verilerinizin belirli
          amaçlarla işlenmesi ve gerekli durumlarda yurt dışına aktarılması için açık rızanızı almak amacıyla
          hazırlanmıştır.
        </p>
        <p>
          Bu metin, <Link to="/kvkk">KVKK Aydınlatma Metni</Link>&apos;nden ayrıdır. Kişisel verilerinizin genel işlenme
          süreçleri hakkında detaylı bilgi için Aydınlatma Metni&apos;ni ve{' '}
          <Link to="/gizlilik-politikasi">Gizlilik Politikası</Link>&apos;nı inceleyebilirsiniz.
        </p>
      </div>

      <div className="legal-consent-block">
        <h3>1. Yurt Dışına Veri Aktarımı İçin Açık Rıza</h3>
        <p>
          NoteSwapp&apos;ın kesintisiz, güvenli ve performanslı çalışabilmesi için teknik altyapı, veri tabanı, kimlik
          doğrulama, depolama ve bulut sunucu hizmet sağlayıcıları olarak küresel ölçekte hizmet veren{' '}
          <strong>Supabase</strong> ve <strong>Firebase</strong> altyapıları kullanılmaktadır. Bu doğrultuda; kimlik,
          iletişim, hesap, akademik profil verilerim ile uygulama içi kullanım loglarımın ve yüklediğim akademik
          dokümanların, hizmetin sunulması, verilerin güvenli şekilde saklanması ve teknik operasyonların yürütülmesi
          amacıyla sunucuları yurt dışında bulunan bu hizmet sağlayıcılara aktarılmasına özgür irademle açık rıza
          veriyorum.
        </p>
        <LegalNote>
          <p>
            Bu aktarım platformun temel altyapısının çalışması için zorunlu olup, onay verilmemesi halinde uygulamanın
            işlevlerinin tam olarak sunulması teknik olarak mümkün olamayacaktır.
          </p>
        </LegalNote>
      </div>

      <div className="legal-consent-block">
        <h3>2. Duyuru, Bilgilendirme ve İletişim İçin Açık Rıza</h3>
        <p>
          NoteSwapp tarafından uygulama güncellemeleri, yeni eklenen özellikler, TÜBİTAK proje duyuruları, kullanıcı
          deneyimi anketleri ve platforma ilişkin akademik bilgilendirmelerin tarafıma e-posta, uygulama içi bildirim veya
          benzeri iletişim kanalları aracılığıyla gönderilmesi amacıyla; ad, soyad, e-posta adresi ve bildirim
          tercihlerimin işlenmesine özgür irademle açık rıza veriyorum.
        </p>
        <LegalNote>
          <p>
            Güvenlik, hesap doğrulama, şifre sıfırlama veya sistemsel hatalara ilişkin zorunlu teknik bilgilendirmeler bu
            rıza kapsamında olmayıp, her halükârda gönderilecektir.
          </p>
        </LegalNote>
      </div>

      <LegalSection title="Açık Rızanın Geri Alınması ve Beyan">
        <p>
          Açık rızamı dilediğim zaman <a href="mailto:noteswapp@gmail.com">noteswapp@gmail.com</a> adresine e-posta
          göndererek geri çekebileceğimi, rızamı geri çekmemin bu tarihten önce gerçekleştirilen hukuka uygun veri işleme
          faaliyetlerini etkilemeyeceğini biliyorum.
        </p>
        <p>
          NoteSwapp KVKK Aydınlatma Metni&apos;ni okuduğumu, haklarım konusunda bilgilendirildiğimi ve yukarıda belirtilen
          maddeler kapsamında kişisel verilerimin işlenmesine ve aktarılmasına özgür irademle onay verdiğimi beyan ederim.
        </p>
        <p style={{ marginTop: 16, fontSize: '0.85rem', color: '#7A8BAD' }}>
          Bu metin, mobil uygulamada kayıt veya ayarlar ekranında sunulan onay kutucukları ile birlikte değerlendirilir.
          Web sitesinde bilgilendirme amacıyla yayınlanmaktadır.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
}
